module.exports = __webpack_public_path__ + "static/media/image-selected.4b22174b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/image-selected.svg
// module id = 771
// module chunks = 0